module.exports = __webpack_public_path__ + "media/src/images/calendar-33cbb609166e894d10521a351572f61f.png";